import { useConnector } from "react-instantsearch"
import connectAutocomplete from "instantsearch.js/cjs/connectors/autocomplete/connectAutocomplete"

function useAutocomplete(props) {
  return useConnector(connectAutocomplete, props)
}

export { useAutocomplete }
